<div class="card">
	<div class="card-header">
		<h1>Configuración general 
			<button class="btn btn-success" tooltip="Guardar todas las configuraciones" (click)="changeConfigsSequentially()" [disabled]="loadingConfig[-1]" *ngIf="isChanged()">
				<i *ngIf="!loadingConfig[-1]"
					class="fa fa-save"></i>
				<span class="spinner-border spinner-border-sm" *ngIf="loadingConfig[-1]"></span>
			</button>
		</h1>
	</div>
	<div class="card-body">
		<div class="row" *ngIf="!loadingServer">
			<div class="col-12 settings-container">
				<div class="settings-list">
					<div class="settings-column" *ngFor="let group of columnOriginalConfigs">
						<ng-container *ngFor="let setting of group">
							<div 
							class="setting-item" 
							[class.setting-item-col]="setting.type == 'string'"
							*ngIf="setting.type!='boolean'" 
							>
								<div class="setting-info">
									<p class="setting-title">{{ setting.displayName }}</p>
									<p class="setting-description">{{ setting.description }}</p>
								</div>
								<ng-container *ngIf="setting.type == 'string'">
									<div class="input-group">
										<input type="text" [disabled]="loading" [(ngModel)]="newConfigs[setting.id].value"
											class="form-control" id="{{setting.name}}" name="{{setting.name}}">
										<button [disabled]="loading" (click)="changeConfig(setting,newConfigs[setting.id].value)"
											*ngIf="setting.value != newConfigs[setting.id].value" class="btn btn-success">
											<i *ngIf="!loadingConfig[setting.id]" class="fa fa-save"></i>
											<span class="spinner-border spinner-border-sm" *ngIf="loadingConfig[setting.id]"></span>
										</button>
									</div>
								</ng-container>
								<ng-container *ngIf="setting.type == 'decimal' || setting.type == 'long'">
									<div class="input-group setting-item-col-2 pl-2">
										<input type="number" [disabled]="loading" [(ngModel)]="newConfigs[setting.id].value"
											class="form-control" id="{{setting.name}}" name="{{setting.name}}">
										<button [disabled]="loading" (click)="changeConfig(setting,newConfigs[setting.id].value)"
											*ngIf="setting.value != newConfigs[setting.id].value" class="btn btn-success">
											<i *ngIf="!loadingConfig[setting.id]" class="fa fa-save"></i>
											<span class="spinner-border spinner-border-sm" *ngIf="loadingConfig[setting.id]"></span>
										</button>
									</div>
								</ng-container>
								<ng-container *ngIf="setting.type == 'long_combo'">
									<div class="input-group setting-item-col-2">
										<select name="{{setting.name}}" [disabled]="loading"
											(change)="changeConfig(setting,newConfigs[setting.id].value)" id="{{setting.name}}"
											class="form-select" [(ngModel)]="newConfigs[setting.id].value">
											<ng-container *ngIf="setting.name=='taxRegime'">
												<option *ngFor="let tax of regimes" value="{{tax.id}}">{{tax.name}}</option>
											</ng-container>
											<ng-container *ngIf="setting.name=='defaultWarehouse'">
												<option *ngFor="let warehouse of warehouses" value="{{warehouse.id}}">
													{{warehouse.name}}
												</option>
											</ng-container>
											<ng-container *ngIf="setting.name=='defaultPriceList'">
												<option *ngFor="let priceList of lists" value="{{priceList.id}}">{{priceList.name}}
												</option>
											</ng-container>
										</select>
										<span class="input-group-text" *ngIf="loadingConfig[setting.id]">
											<span class="spinner-border spinner-border-sm"></span>
										</span>
									</div>
								</ng-container>
							</div>
						</ng-container>
					</div>
				</div>
			</div>

			
			<div class="col-12 settings-container">
				<h2 class="settings-title">Ajustes Generales</h2>
				<div class="settings-list">
					<div class="settings-column" *ngFor="let group of columnGeneralConfigs">
						<ng-container *ngFor="let setting of group">
							<div class="setting-item" *ngIf="setting.type=='boolean'">
								<div class="setting-info">
								<p class="setting-title">{{ setting.displayName }}</p>
								<p class="setting-description">{{ setting.description }}</p>
								</div>
								<div class="toggle-setting">
									<label class="settings-switch">
										<input
											type="checkbox"
											class="settings-switch-input"
											[checked]="setting.value=='true'"
											[disabled]="loadingConfig[setting.id]"
											(click)="newConfigs[setting.id].value = (newConfigs[setting.id].value =='true')? 'false':'true'; changeConfig(setting,newConfigs[setting.id].value)"
										/>
										<span class="settings-switch-track">
											<span class="settings-switch-thumb" *ngIf="!loadingConfig[setting.id]"></span>
											<span *ngIf="loadingConfig[setting.id]" class="spinner-border spinner-border-sm text-white"></span>
										</span>
									</label>
								</div>
							</div>
						</ng-container>
					</div>
				</div>
			</div>

			<div class="col-12 settings-container" *ngIf="fiscalConfigs.length > 0">
				<h2 class="settings-title">Automatización Fiscal</h2>
				<div class="settings-list">
					<div class="settings-column" *ngFor="let group of columnFiscalConfigs">
						<ng-container *ngFor="let setting of group">
							<div class="setting-item" *ngIf="setting.type=='boolean'">
								<div class="setting-info">
								<p class="setting-title">{{ setting.displayName }}</p>
								<p class="setting-description">{{ setting.description }}</p>
								</div>
								<div class="toggle-setting">
									<label class="settings-switch">
										<input
											type="checkbox"
											class="settings-switch-input"
											[checked]="setting.value=='true'"
											[disabled]="loadingConfig[setting.id]"
											(click)="newConfigs[setting.id].value = (newConfigs[setting.id].value =='true')? 'false':'true'; changeConfig(setting,newConfigs[setting.id].value)"
										/>
										<span class="settings-switch-track">
											<span class="settings-switch-thumb" *ngIf="!loadingConfig[setting.id]"></span>
											<span *ngIf="loadingConfig[setting.id]" class="spinner-border spinner-border-sm"></span>
										</span>
									</label>
								</div>
							</div>
						</ng-container>
					</div>
				</div>
			</div>

			<div class="col-12 settings-container" *ngIf="taxesConfigs.length > 0">
				<h2 class="settings-title">Impuestos</h2>
				<div class="settings-list">
					<div class="settings-column" *ngFor="let group of columnTaxesConfigs">
						<ng-container *ngFor="let setting of group">
							<div class="setting-item" *ngIf="setting.type=='boolean'">
								<div class="setting-info">
								<p class="setting-title">{{ setting.displayName }}</p>
								<p class="setting-description">{{ setting.description }}</p>
								</div>
								<div class="toggle-setting">
									<label class="settings-switch">
										<input
											type="checkbox"
											class="settings-switch-input"
											[checked]="setting.value=='true'"
											[disabled]="loadingConfig[setting.id]"
											(click)="newConfigs[setting.id].value = (newConfigs[setting.id].value =='true')? 'false':'true'; changeConfig(setting,newConfigs[setting.id].value)"
										/>
										<span class="settings-switch-track">
											<span class="settings-switch-thumb" *ngIf="!loadingConfig[setting.id]"></span>
											<span *ngIf="loadingConfig[setting.id]" class="spinner-border spinner-border-sm"></span>
										</span>
									</label>
								</div>
							</div>
						</ng-container>
					</div>
				</div>
			</div>

			<div class="col-12 settings-container" *ngIf="purchaseOrderConfigs.length > 0">
				<h2 class="settings-title">Órdenes de Compra - OC</h2>
				<div class="settings-list">
					<div class="settings-column" *ngFor="let group of columnPurchaseOrderConfigs">
						<ng-container *ngFor="let setting of group">
							<div class="setting-item" *ngIf="setting.type=='boolean'">
								<div class="setting-info">
								<p class="setting-title">{{ setting.displayName }}</p>
								<p class="setting-description">{{ setting.description }}</p>
								</div>
								<div class="toggle-setting">
									<label class="settings-switch">
										<input
											type="checkbox"
											class="settings-switch-input"
											[checked]="setting.value=='true'"
											[disabled]="loadingConfig[setting.id]"
											(click)="newConfigs[setting.id].value = (newConfigs[setting.id].value =='true')? 'false':'true'; changeConfig(setting,newConfigs[setting.id].value)"
										/>
										<span class="settings-switch-track">
											<span class="settings-switch-thumb" *ngIf="!loadingConfig[setting.id]"></span>
											<span *ngIf="loadingConfig[setting.id]" class="spinner-border spinner-border-sm"></span>
										</span>
									</label>
								</div>
							</div>
						</ng-container>
					</div>
				</div>
			</div>

			<div class="col-12 settings-container" *ngIf="ordersConfigs.length > 0">
				<h2 class="settings-title">Pedidos</h2>
				<div class="settings-list">
					<div class="settings-column" *ngFor="let group of columnOrderConfigs">
						<ng-container *ngFor="let setting of group">
							<div class="setting-item" *ngIf="setting.type=='boolean'">
								<div class="setting-info">
								<p class="setting-title">{{ setting.displayName }}</p>
								<p class="setting-description">{{ setting.description }}</p>
								</div>
								<div class="toggle-setting">
									<label class="settings-switch">
										<input
											type="checkbox"
											class="settings-switch-input"
											[checked]="setting.value=='true'"
											[disabled]="loadingConfig[setting.id]"
											(click)="newConfigs[setting.id].value = (newConfigs[setting.id].value =='true')? 'false':'true'; changeConfig(setting,newConfigs[setting.id].value)"
										/>
										<span class="settings-switch-track">
											<span class="settings-switch-thumb" *ngIf="!loadingConfig[setting.id]"></span>
											<span *ngIf="loadingConfig[setting.id]" class="spinner-border spinner-border-sm"></span>
										</span>
									</label>
								</div>
							</div>
						</ng-container>
					</div>
				</div>
			</div>

		</div>
		<div class="grid-container" *ngIf="!loadingServer">
		</div>
		<app-loading-animation *ngIf="loadingServer" [height]="'50vh'"></app-loading-animation>
	</div>
</div>